import Vue       from "vue";
import ElementUI from "element-ui";
import locale    from "element-ui/lib/locale/lang/el";
import VueI18n   from "vue-i18n";
import messages  from "@/i18n/messages";
import "@/assets/styles/app.scss";

import App    from "./App.vue";
import router from "./router";
import store  from "./store";
import "@/misc/register-service-worker";
import "@/misc/handle-network-status";
import "@/firebase/init";
import "@/firebase/authentication";
import "@/misc/handle-apple-install-prompt";
import "pwacompat";

Vue.use(
    ElementUI,
    {
        locale
    }
);
Vue.use(VueI18n);
const i18n = new VueI18n(
    {
        locale: "el",
        messages
    }
);

Vue.config.productionTip = false;

new Vue(
    {
        router,
        store,
        render: h => h(App),
        i18n
    }
).$mount("#app");